export default class Slider {

  constructor() {
      
  }

  init() {
      
      $(window).resize(() =>{
        
      });
  }
}




